<header>
  <div class="logo" id="logo-cetelem">
  </div>
  <pvmo-user-connection/>
</header>
